




import { defineComponent, onMounted } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { onLogout, client } from '@/useApollo';

const Logout = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(async () => {
      onLogout(client);
      router.push({ name: 'Login' });
    });
  },
});

export default Logout;
